<template>
  <aside class="control-sidebar control-sidebar-dark">
    <!-- Create the tabs -->
    <!-- <ul class="nav nav-tabs nav-justified control-sidebar-tabs">
      <li><a href="#control-sidebar-home-tab" data-toggle="tab"><i class="fa fa-palette" /></a></li>
    </ul> -->
    <!-- Tab panes -->
    <div class="tab-content">
      <!-- Home tab content -->
      <div id="control-sidebar-home-tab" class="tab-pane active">
        <h4 class="control-sidebar-heading">
          更换主题
        </h4>
        <ul class="list-unstyled clearfix">
          <li v-for="(item, index) in skins" :key="index" class="skin-item">
            <a href="javascript:void(0)" :data-skin="item.skin" class="clearfix full-opacity-hover" @click="changeTheme(item.skin)">
              <div>
                <span class="bannerBg" :style="'background:' + item.bg.logo" />
                <span class="navBg" :style="'background:' + item.bg.nav" />
              </div>
              <div>
                <span class="sidebarBg" :style="'background:' + item.bg.sidebar" />
                <span class="bodyBg" :style="'background:' + item.bg.body" />
              </div>
            </a>
            <p class="text-center no-margin">
              {{ item.name }}
            </p>
          </li>
        </ul>
      </div>
    </div>
  </aside>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'ControlSidebar',
  data() {
    return {
      skins: [
        { name: '蓝色', skin: 'skin-blue',
          bg: { logo: '#367fa9', sidebar: '#222d32', nav: '#0073b7', body: '#f4f5f7' }
        },
        { name: '黑色', skin: 'skin-black',
          bg: { logo: '#fefefe', sidebar: '#222', nav: '#fefefe', body: '#f4f5f7' }
        },
        { name: '紫色', skin: 'skin-purple',
          bg: { logo: '#555299', sidebar: '#222d32', nav: '#605ca8', body: '#f4f5f7' }
        },
        { name: '绿色', skin: 'skin-green',
          bg: { logo: '#008d4c', sidebar: '#222d32', nav: '#00a65a', body: '#f4f5f7' }
        },
        { name: '红色', skin: 'skin-red',
          bg: { logo: '#d33724', sidebar: '#222d32', nav: '#dd4b39', body: '#f4f5f7' }
        },
        { name: '黄色', skin: 'skin-yellow',
          bg: { logo: '#db8b0b', sidebar: '#222d32', nav: '#f39c12', body: '#f4f5f7' }
        },
        { name: '淡蓝', skin: 'skin-blue-light',
          bg: { logo: '#367fa9', sidebar: '#f9fafc', nav: '#3c8dbc', body: '#f4f5f7' }
        },
        { name: '淡黑', skin: 'skin-black-light',
          bg: { logo: '#fefefe', sidebar: '#f9fafc', nav: '#fefefe', body: '#f4f5f7' }
        },
        { name: '淡紫', skin: 'skin-purple-light',
          bg: { logo: '#555299', sidebar: '#f9fafc', nav: '#605ca8', body: '#f4f5f7' }
        },
        { name: '淡绿', skin: 'skin-green-light',
          bg: { logo: '#008d4c', sidebar: '#f9fafc', nav: '#00a65a', body: '#f4f5f7' }
        },
        { name: '淡红', skin: 'skin-red-light',
          bg: { logo: '#d33724', sidebar: '#f9fafc', nav: '#dd4b39', body: '#f4f5f7' }
        },
        { name: '淡黄', skin: 'skin-yellow-light',
          bg: { logo: '#db8b0b', sidebar: '#f9fafc', nav: '#f39c12', body: '#f4f5f7' }
        }
      ]
    }
  },
  methods: {
    ...mapMutations([
      'setSkin'
    ]),
    changeTheme(skin) {
      this.setSkin(skin)
    }
  }
}
</script>

<style lang="less" scoped>
    .skin-item {
        float:left;
        width: 33.33333%;
        padding: 5px;
        a {
            display: block;
            box-shadow: 0 0 3px rgba(0,0,0,0.4)
        }
        p {
            font-size: 9pt;
        }
        .bannerBg {
            display:block;
            width: 20%;
            float: left;
            height: 7px
        }
        .navBg{
            display:block;
            width: 80%;
            float: left;
             height: 7px;
        }
        .sidebarBg {
            display:block;
            width: 20%;
            float: left;
            height: 20px;
        }
        .bodyBg {
            display:block;
            width: 80%;
            float: left;
            height: 20px;
        }
    }
</style>
